import { FaLink } from "react-icons/fa";

import { getFirebaseConsoleUrl } from "../../api/firestoreBaseApi";
import { getRtdbConsoleUrl } from "../../api/rtdbBaseApi";

export default function FirestoreDevMenuItem({
    as: Component,
    text,
    path,
    rtdb = false,
}) {
    function visit() {
        const url = rtdb
            ? getRtdbConsoleUrl(path)
            : getFirebaseConsoleUrl(path);

        window.open(url);
    }

    return (
        <Component onClick={visit}>
            <FaLink
                className="me-2 text-primary"
                style={{ marginTop: "-2px" }}
            />
            {text || (rtdb ? "Realtime Database" : "Firestore")}
        </Component>
    );
}
